import { observer } from 'mobx-react'
import { FC } from 'react'
import { useTranslation } from 'next-i18next'
import { ICompanyBase } from '../../../types'
import styles from './index.module.scss'
import { getCompanyLogo } from '../../../utils'
import { Avatar } from '../../atoms/Avatar'
import { CompanyCardWithJobHeaderContent } from '../CompanyCardWithJobHeaderContent'

type Props = {
  company: ICompanyBase
}

export const CompanyCardWithJobHeader: FC<Props> = observer(({ company }) => {
  const { t } = useTranslation('jobs')

  return (
    <>
      <div className={styles.avatar}>
        <Avatar src={getCompanyLogo(company)} alt={company.name} />
      </div>
      <div className={styles.content}>
        <CompanyCardWithJobHeaderContent company={company} />
      </div>
      <img src='/images/common/arrow_gray_icon.svg' className={styles.arrowIcon} alt={t('詳細検索条件')} />
    </>
  )
})
